import {
    Button, Grid
} from '@material-ui/core';
import React from 'react';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { globalStyles } from '../../../assets/globalStyles';
import { ExportNetzereignisToExcel } from "../../../features/excelExport/ExportToExcel";
import { isAuthorized, rollen } from '../../../utils/auth/authConfig';
import { selectEditEntry, selectNetzereignisLoading, selectNetzsereignisseListe, startNewEntry } from './netzereignisseSlice';
import { useStyles } from './netzereignisseStyles';

export const NetzereignisseActionheader = (): JSX.Element => {

    const dispatch = useAppDispatch();

    const classes = {
        ...useStyles(),
        ...globalStyles(),
    };

    const
        netzereignisseListe = useAppSelector(selectNetzsereignisseListe),
        editEntry: boolean = useAppSelector(selectEditEntry),
        netzereignisLoading: boolean = useAppSelector(selectNetzereignisLoading);

    return (

        <Grid item md={3} style={{ paddingRight: "24px", paddingTop: "0px", textAlign: "right" }}>
            {isAuthorized([rollen.admin, rollen.betrieb, rollen.technik, rollen.netzwirtschaft]) ? <Button
                variant="contained"
                onClick={() => dispatch(startNewEntry())}
                color="secondary"
                className={classes.showDuoButton}
                disabled={editEntry}
            >
                Neues Netzereignis
            </Button> : ""}

            <Button
                variant="contained"
                onClick={() => {
                    ExportNetzereignisToExcel(netzereignisseListe, "netzereignise")
                }}
                color="default"
                className={classes.showDuoButton}
                disabled={editEntry || netzereignisLoading}
            >
                Export
            </Button>
        </Grid>

    )
}
